<template>
    <page>
        <module :title="id ? '编辑特殊价格申请' : '新建特殊价格申请'">
			<c-tip v-if="rejectedReason" style="top: 47px;">驳回原因：{{rejectedReason}}</c-tip>
			
            <c-form ref="form">
                <c-form-item label="目标用户" required>
                <m-operate>
                  <c-button color="gray" hollow @click="$refs.memberSelector.open()">添加用户</c-button>
                  <c-button color="gray" hollow @click="setMemberTime">批量设置时间</c-button>
                </m-operate>

                <c-table ref="memberList" v-model="memberList" height="250" :paging="false" border>
                  <c-table-column type="selector"  width="20"></c-table-column>

                  <c-table-column
                      label="会员手机号"
                      name="user_manage_mobilephone"
                      width="120"
                  ></c-table-column>

                  <c-table-column
                      label="会员头像/昵称"
                      name="head_photo"
                      width="120"
                  >
                    <template v-slot="{data}">
                      <div class="flex-center-cross">
                        <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                        <span>{{data.nick_name||'--'}}</span>
                      </div>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="用户名"
                      name="login_name"
                      width="60"
                  >
                    <template v-slot="{data}">
                      <span v-if="data.login_name && data.login_name!=''">{{data.login_name}}</span>
                      <span v-else>--</span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      required
                      label="生效时间"
                      width="140"
                  >
                    <template v-slot="row">
                      <c-datetime v-model="row.data.begin_time" aria-readonly="true"></c-datetime>
                    </template>
                  </c-table-column>

                  <c-table-column
                      required
                      label="截止时间"
                      width="140"
                  >
                    <template v-slot="row">
                      <c-datetime v-model="row.data.end_time" aria-readonly="true"></c-datetime>
                    </template>
                  </c-table-column>

                  <c-table-column
                      type="button"
                      fixed="right"
                      label="操作"
                      width="60"
                  >
                    <template v-slot="row">
                      <c-table-button @click="row.remove()">删除</c-table-button>
                    </template>
                  </c-table-column>
                </c-table>
              </c-form-item>
                <c-form-item type="radio" label="管控方式" name="type" v-model="type" :options="typeOptions" required word="请选择价格管控的类型"></c-form-item>
                <c-form-item label="目标品牌" v-show="type == 2" required>
                  <m-operate>
                    <c-button color="gray" hollow @click="$refs.brandSelector.open()">添加品牌</c-button>
                    <c-button color="gray" hollow @click="setPreferentialType">批量设置优惠方式</c-button>
                    <c-button color="gray" hollow @click="setDiscount">批量设置折扣</c-button>
                    <c-button color="gray" hollow @click="setReducedMoney">批量设置减免金额</c-button>
                  </m-operate>

                  <c-table ref="brandList" v-model="brandList" height="auto" :paging="false" border>
                    <c-table-column type="selector"  width="20"></c-table-column>
                    <c-table-column
                        label="品牌"
                        name="brand_name"
                        width="120"
                    >
                      <template v-slot="{data}">
                        <div class="flex-center">
                          <c-image v-if="data.logo" :src="data.logo" size="46" preview></c-image>
                          <p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{data.brand_name}}</p>
                        </div>
                      </template>
                    </c-table-column>

                    <c-table-column
                        label="优惠方式"
                        width="80"
                    >
                      <template v-slot="{data}">
                        <c-select v-model="data.preferential_type"  width="60" :options="preferentialTypeOptions"></c-select>
                      </template>
                    </c-table-column>

                    <c-table-column
                        label="折扣"
                        width="100"
                    >
                      <template v-slot="{data}">
                        <c-input v-if="data.preferential_type==1"  decimal="1" :limit="[0.1,10]" v-model="data.discount" width="80" type="number" style="margin: 0 5px;" word="折"></c-input>
                        <span v-else>--</span>
                      </template>
                    </c-table-column>

                    <c-table-column
                        label="减免金额"
                        width="100"
                    >
                      <template v-slot="{data}">
                        <c-input v-if="data.preferential_type==2"  decimal="2" :limit="[0.01,9999]" v-model="data.reduced_money" width="80" type="number" style="margin: 0 5px;" word="元"></c-input>
                        <span v-else>--</span>
                      </template>
                    </c-table-column>

                    <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="80"
                    >
                      <template v-slot="row">
                        <c-table-button @click="row.remove()">删除</c-table-button>
                      </template>
                    </c-table-column>
                  </c-table>
                </c-form-item>
                <c-form-item label="目标商品" v-show="type == 1" required>
                <m-operate>
                  <c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
                  <c-button color="gray" hollow @click="setPreferentialType()">批量设置优惠方式</c-button>
                  <c-button color="gray" hollow @click="setDiscount">批量设置折扣</c-button>
                  <c-button color="gray" hollow @click="setReducedMoney">批量设置减免金额</c-button>
                </m-operate>
                <c-table ref="productList" v-model="productList" height="auto" :paging="false" border>
                  <c-table-column type="selector" width="20"></c-table-column>

                  <c-table-column
                      label="商品信息"
                      name="product_name"
                      width="200"
                  >
                    <template v-slot="{data}">
                      <div class="flex-center">
                        <c-image :src="oss(data.product_img_url, 46, 46)" size="46" preview></c-image>
                        <p v-if="data.product_itemnumber">【{{data.product_itemnumber}}】</p>
                        <p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{data.product_name}}</p>
                      </div>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="价格"
                      name="product_price"
                      width="120"
                  >
                    <template v-slot="{data}">
                      ￥{{data.product_price_min}}
                      <span v-if="data.product_price_max"> - ￥{{data.product_price_max}}</span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="优惠方式"
                      width="120"
                  >
                    <template v-slot="{data}">
                      <c-select v-model="data.preferential_type"  width="60" :options="preferentialTypeOptions"></c-select>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="折扣"
                      width="100"
                  >
                    <template v-slot="{data}">
                      <c-input v-if="data.preferential_type==1" decimal="1" :limit="[0.1,10]" v-model="data.discount" width="80" type="number" style="margin: 0 5px;" word="折"></c-input>
                      <span v-else>--</span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="减免金额"
                      width="100"
                  >
                    <template v-slot="{data}">
                      <c-input v-if="data.preferential_type==2"  decimal="2" :limit="[0.01,9999]" v-model="data.reduced_money" width="80" type="number" style="margin: 0 5px;" word="元"></c-input>
                      <span v-else>--</span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="促销价"
                      name="promotion_price"
                      width="140"
                  >
                    <template v-slot="{data}">
                              <span v-if="data.preferential_type==1 && data.discount" >
                                        ￥{{parseFloat(data.product_price_min * data.discount / 10).toFixed(2)}}
                                        <span v-if="data.product_price_max">
                                            - ￥{{parseFloat(data.product_price_max * data.discount / 10).toFixed(2)}}
                                        </span>
                              </span>
                      <span v-if="data.preferential_type==2 && data.reduced_money" >
                                        ￥{{parseFloat(data.product_price_min - data.reduced_money).toFixed(2)}}
                                        <span v-if="data.product_price_max">
                                            - ￥{{parseFloat(data.product_price_max - data.reduced_money).toFixed(2)}}
                                        </span>
                              </span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      type="button"
                      fixed="right"
                      label="操作"
                      width="60"
                  >
                    <template v-slot="row">
                      <c-table-button @click="row.remove()">删除</c-table-button>
                    </template>
                  </c-table-column>
                </c-table>
              </c-form-item>
            </c-form>

            <template slot="button">
                <c-button size="m" @click="submit(1)">确定提交</c-button>
                <c-button size="m" v-if="this.state==0||this.state==-1" hollow @click="submit(0)">暂存草稿</c-button>
            </template>
        </module>
      
        <c-dialog ref="memberTimeDialog" title="批量设置生效起止时间" width="400" height="180" @resolve="setMemberTimeHandle">
          <c-form ref="timeForm">
              <c-form-item type="datetime" label="生效时间" date-type="datetime" name="begin_time"></c-form-item>
              <c-form-item type="datetime" label="截止时间" date-type="datetime" name="end_time"></c-form-item>
          </c-form>
        </c-dialog>

        <c-dialog ref="preferentialTypeDialog" title="批量设置优惠方式" width="400" height="180" @resolve="setPreferentialTypeHandle">
          <c-form>
              <c-form-item label="优惠方式" v-model="preferential_type"  type="select" :options="preferentialTypeOptions"></c-form-item>
          </c-form>
        </c-dialog>

        <c-dialog ref="discountDialog" title="批量优惠折扣" width="400" height="150" @resolve="setDiscountHandle">
          <c-form>
            <c-form-item  label="折扣" required>
              <c-input v-model="discount" decimal="1" width="200" type="number" :limit="[0.1, 10]" style="margin: 0 5px;"></c-input>
            </c-form-item>
          </c-form>
        </c-dialog>

        <c-dialog ref="reducedMoneyDialog" title="批量减免金额" width="400" height="150" @resolve="setReducedMoneyHandle">
          <c-form>
            <c-form-item  label="减免金额" required>
              <c-input v-model="reduced_money" decimal="2" width="200" type="number" :limit="[0.01, 9999]" style="margin: 0 5px;"></c-input>
            </c-form-item>
          </c-form>
        </c-dialog>

        <member-selector ref="memberSelector" multiple @resolve="selectHandle($event, 'memberList', 'platform_user_id')"></member-selector>
        <brand-selector ref="brandSelector" multiple @resolve="brandSelectHandle"></brand-selector>
        <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
    import memberSelector from '@/components/service/member_selector.vue'
    import brandSelector from '@/components/service/brand_selector.vue'
    import {mapState} from 'vuex'
    import productSelector from "@/components/service/product_selector";

    export default {
        name: 'special_price_edit',

        components: {
            memberSelector, brandSelector,productSelector
        },

        props: {
            id: String
        },

        data() {
            return {
                state:-1,
                memberList: [],
                brandList: [],
                productList: [],
                type: 1,/**类型 2：品牌 1：商品**/
                typeOptions: [
                  {name: '按商品',value: 1},
                  {name: '按品牌',value: 2}
                ],
                preferential_type:1,
                discount:'',
                reduced_money:'',
                preferentialTypeOptions: [
                    {name: '基础价格打折',value: 1},
                    {name: '减免固定金额',value: 2}
                ],
                begin_time:'',
                end_time:'',
				rejectedReason: ''
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getDetail();
            }
        },

        mounted() {
            this.id && this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/special_price/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                        this.state = data.state||0;
                        this.memberList = data.user_list || [];
                        this.brandList = data.brand_list || [];
                        this.productList = data.product_list || [];
                        this.type = data.type || 1;
						this.rejectedReason = data.rejected_reason;
                    }
                });
            },

            selectHandle(list, ref, key) {
                list = list.filter(item => {
                    return !this[ref].find(row => {
                        return row[key] == item[key];
                    });
                });
                this[ref] = this[ref].concat(list);
            },
            /***
             * 选择品牌-确定响应
             * @param list
             */
            brandSelectHandle(list) {
              list = list.filter(item => {
                    return !this.brandList.find(row => {
                        return row.id == item.id;
                    });
              });
              this.brandList = this.brandList.concat(list).map(item => {
                  item.preferential_type = 1;//默认打折
                  return item;
              });;
            },
            /***
             * 选择商品-确定响应
             * @param list
             */
            productSelectHandle(list) {
              list = list.filter(item => {
                    return !this.productList.find(row => {
                        return row.product_id == item.product_id;
                    });
              });
              this.productList = this.productList.concat(list).map(item => {
                  item.preferential_type = 1;//默认打折
                  return item;
              });;
            },
            /**
             * 批量设置【目标用户起止时间】
             * @param stop
             */
            setMemberTime(){
              this._limit = this.$refs.memberList.getRow('selected');
              if (!this._limit.length) {
                this.$message({
                    icon: 'fail',  // 图标（success：成功，fail：失败）
                    text:'请选择需要设置时间的目标用户'
                });
                delete this._limit;
                return;
              }
              this.$refs.timeForm.clear();
              this.$refs.memberTimeDialog.open();
            },
            /**
             * 批量设置【目标用户起止时间】 -响应事件
             * @param stop
             */
            setMemberTimeHandle(stop) {
             var timeForm = this.$refs.timeForm.serialize();
              if (!timeForm.begin_time) {
                  stop();
                  this.$message({
                    icon: 'fail',  // 图标（success：成功，fail：失败）
                    text: '请填写生效时间'
                  });
                  return;
              }
              if (!timeForm.end_time) {
                  stop();
                  this.$message({
                    icon: 'fail',  // 图标（success：成功，fail：失败）
                    text: '请填写截止时间'
                  });
                  return;
              }
              this._limit.forEach(row => {
                row.update({
                  begin_time: timeForm.begin_time,
                  end_time: timeForm.end_time
                });
              });
            },
            /**
             * 批量设置【优惠方式】
             * @param stop
             */
            setPreferentialType(){
                this._limit = [];
                if (this.type==1){
                    this._limit = this.$refs.productList.getRow('selected');
                }else {
                    this._limit = this.$refs.brandList.getRow('selected');
                }
                if (!this._limit.length) {
                    this.$message({
                      icon: 'fail',  // 图标（success：成功，fail：失败）
                      text: this.type==1?'请选择商品':'请选择品牌'
                    });
                    delete this._limit;
                    return;
                }
                this.$refs.preferentialTypeDialog.open();
            },
            /**
             * 选择优惠方式响应事件
             * @param stop
            */
            setPreferentialTypeHandle(stop) {
                if (!this.preferential_type) {
                    stop();
                    this.$message({
                      icon: 'fail',  // 图标（success：成功，fail：失败）
                      text: '请选择优惠方式'
                    });
                    return;
                }
                this._limit.forEach(row => {
                    row.update({
                      preferential_type: this.preferential_type
                    });
                });
            },
            /**
             * 设置折扣
             * */
            setDiscount() {
              this._limit = [];
              if (this.type==1){
                  this._limit = this.$refs.productList.getRow('selected');
              }else {
                  this._limit = this.$refs.brandList.getRow('selected');
              }
              if (!this._limit.length) {
                this.$message({
                  icon: 'fail',  // 图标（success：成功，fail：失败）
                  text: this.type==1?'请选择商品':'请选择品牌'
                });
                delete this._limit;
                return;
              }
              this.discount = '';
              this.$refs.discountDialog.open();
            },
            /**
             * 设置折扣 - 响应事件
             * @param stop
             */
            setDiscountHandle(stop) {
                if (!this.discount) {
                    stop();
                    this.$message({
                        icon: 'fail',  // 图标（success：成功，fail：失败）
                        text: '请填写折扣信息'
                    });
                    return;
                }
                this._limit.forEach(row => {
                    row.update({
                      discount: this.discount
                    });
                });
            },
            /**
             * 设置减免金额
             * */
            setReducedMoney() {
              this._limit = [];
              if (this.type==1){
                  this._limit = this.$refs.productList.getRow('selected');
              }else {
                  this._limit = this.$refs.brandList.getRow('selected');
              }
              if (!this._limit.length) {
                this.$message({
                    icon: 'fail',  // 图标（success：成功，fail：失败）
                    text: this.type==1?'请选择商品':'请选择品牌'
                });
                delete this._limit;
                return;
              }
              this.reduced_money = '';
              this.$refs.reducedMoneyDialog.open();
            },
            /**
             * 设置减免金额 - 响应事件
             * @param stop
             */
            setReducedMoneyHandle(stop) {
                if (!this.reduced_money) {
                      stop();
                      this.$message({
                          icon: 'fail',  // 图标（success：成功，fail：失败）
                          text: '请填写减免金额'
                      });
                      return;
                }
                this._limit.forEach(row => {
                    row.update({
                      reduced_money: this.reduced_money
                    });
                });
            },
            /**
             * 提交数据
             * @param state
             */
            submit(state) {
                this.$refs.form.submit({
                    url: this.id ? '/special_price/edit' : '/special_price/add',
                    rule: {
                        member_list: [{
                            type: 'function',
                            fun: () => {
                                return !!this.memberList.length;
                            },
                            word: '请选择目标用户'
                        }],
                        member_config: [{
                            type: 'function',
                            fun: () => {
                                return !this.memberList.find(item => {
                                    return !item.begin_time || !item.end_time;
                                });
                            },
                            word: '请设置生效时间以及截止时间'
                        }],
                        brand_list: [{
                            type: 'function',
                            fun: () => {
                              if(this.type == 2){
                                return !!this.brandList.length;
                              }else return true;
                            },
                            word: '请至少添加一个品牌'
                        }],
                        brand_config: [{
                            type: 'function',
                            fun: () => {
                              if(this.type == 2){
                                  return !this.brandList.find(item => {
                                      return !item.preferential_type||(item.preferential_type==1 && !item.discount)||(item.preferential_type==2 && !item.reduced_money);
                                  });
                              }else return true;
                            },
                            word: '请完善品牌优惠信息'
                        }],
                        product_list: [{
                          type: 'function',
                          fun: () => {
                            if(this.type == 1){
                                return !!this.productList.length;
                            }else return true;
                          },
                          word: '请至少添加一件商品'
                        }],
                        product_config: [{
                            type: 'function',
                            fun: () => {
                              if(this.type == 1){
                                  return !this.productList.find(item => {
                                      return !item.preferential_type||(item.preferential_type==1 && !item.discount)||(item.preferential_type==2 && !item.reduced_money);
                                  });
                              }else return true;
                            },
                            word: '请完善商品优惠信息'
                        }],
                    },
                    dataFormatter: data => {
                        this.id && (data.id = this.id);
                        data.type = this.type;
                        data.state = state;
                        data.user_list = Array.from(this.memberList, item => {
                            return {
                                id: item.platform_user_id,
                                begin_time: item.begin_time,
                                end_time: item.end_time,
                            }
                        });
                        if(this.brandList) {
                            data.brand_list = Array.from(this.brandList, item => {
                              return {
                                  id: item.id,
                                  preferential_type: item.preferential_type,
                                  reduced_money: item.preferential_type==2?item.reduced_money:0,
                                  discount: item.preferential_type==1?item.discount:0
                              }
                            });
                        }
                        if(this.productList) {
                            data.product_list = Array.from(this.productList, item => {
                              return {
                                  product_id: item.product_id,
                                  preferential_type: item.preferential_type,
                                  reduced_money: item.preferential_type==2?item.reduced_money:0,
                                  discount: item.preferential_type==1?item.discount:0
                              }
                            });
                        }
                        return data;
                    },

                    success: () => {
                        this.$message({
                            icon: 'success',  // 图标（success：成功，fail：失败）
                            text: '保存成功'
                        });
                        this.$bus.$emit('specialPriceList.update', {});
                        this.redirectTo('/special_price_list');
                    }
                })
            }
        }
    }
</script>